import React from 'react';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import 'dayjs/locale/pt';
import DateFnsUtils from '@date-io/date-fns';
import deLocale from 'date-fns/locale/pt-BR';
import { TextField } from '@mui/material';
import { useFormikContext } from 'formik';

function DatePickerContext({
  label, name, onChangeCallback = () => {}, ...rest
}) {
  const {
    getFieldProps, getFieldMeta, setFieldValue, setFieldTouched,
  } = useFormikContext();
  const fieldProps = getFieldProps(name);
  const fieldMeta = getFieldMeta(name);

  return (
    <LocalizationProvider adapterLocale={deLocale} dateAdapter={DateFnsUtils}>
      <DatePicker
        {...fieldProps}
        {...rest}
        InputLabelProps={{ style: { pointerEvents: 'auto' } }}
        label={label}
        name={name}
        variant="inline"
        inputVariant="outlined"
        invalidDateMessage="Data Inválida"
        format="dd/MM/yyyy"
        fullWidth
        size="medium"
        onChange={(date) => {
          setFieldValue(name, date);
          onChangeCallback(date);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            onBlur={() => setFieldTouched(name, true)}
            error={fieldMeta.touched && fieldMeta.error}
            helperText={fieldMeta.touched && fieldMeta.error}
            fullWidth
          />
        )}
      />
    </LocalizationProvider>
  );
}

export default DatePickerContext;
